// Browser-side memory of the guided chat, kept in sessionStorage only (this tab, gone when it is
// closed; nothing is sent anywhere):
//
//   intake draft   the answers typed so far (never attachments), per identity, so a refresh or an
//                  accidental close does not lose a half-written request. Dropped on submit/cancel.
//   FAQ session    a random id used ONLY to count one helpful / not-helpful vote per visitor. It is
//                  not linked to a name, e-mail or account.
//
// Every access is wrapped: private windows and blocked storage must never break the chat.

const DRAFT_KEY = "lud-copilot-intake-v1";
const SESSION_KEY = "lud-copilot-faq-session";
const DRAFT_TTL_MS = 24 * 60 * 60 * 1000;

let memoryDraft = {};
let memorySession = null;

const randomId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID().replace(/-/g, "");
  if (window.crypto?.getRandomValues) return Array.from(window.crypto.getRandomValues(new Uint8Array(16)), (b) => b.toString(16).padStart(2, "0")).join("");
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`.padEnd(24, "0");
};

export function faqSessionId() {
  try {
    const stored = sessionStorage.getItem(SESSION_KEY);
    if (stored && /^[A-Za-z0-9_-]{16,64}$/.test(stored)) return stored;
    const id = randomId();
    sessionStorage.setItem(SESSION_KEY, id);
    return id;
  } catch {
    memorySession = memorySession || randomId();
    return memorySession;
  }
}

function readAll() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(DRAFT_KEY) || "{}");
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return memoryDraft;
  }
}

function writeAll(all) {
  try {
    sessionStorage.setItem(DRAFT_KEY, JSON.stringify(all));
  } catch {
    memoryDraft = all;
  }
}

export function loadIntakeDraft(identity) {
  const entry = readAll()[identity];
  if (!entry || typeof entry !== "object" || !entry.data || Date.now() - Number(entry.savedAt || 0) > DRAFT_TTL_MS) return null;
  return entry.data;
}

export function saveIntakeDraft(identity, data) {
  writeAll({ ...readAll(), [identity]: { savedAt: Date.now(), data } });
}

export function clearIntakeDraft(identity) {
  const all = readAll();
  if (!(identity in all)) return;
  delete all[identity];
  writeAll(all);
}

// Only for tests.
export function resetDraftStoreMemory() {
  memoryDraft = {};
  memorySession = null;
}
